<ng-content select="kb-footer-link"></ng-content> <!-- https://github.com/angular/angular/issues/50543 -->

<ng-content select="kb-extended-footer"></ng-content>
<nav class="meta-navigation" [attr.aria-label]="metaNavigationLabel">
  <ul>
    @for (link of links(); track link) {
      <li>
        <a kb-link [kbRouterOrExternalLink]="link.href" [attr.target]="link.target">
          <ng-container *ngTemplateOutlet="link.content()"></ng-container>
        </a>
      </li>
    }
  </ul>
</nav>
